var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuotes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.975,
    height: 26,
    viewBox: "0 0 33.975 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_248",
    "data-name": "Group 248",
    transform: "translate(-358.173 -391.317)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28425",
    "data-name": "Path 28425",
    d: "M530.028,391.858l1.7,2.457a15.938,15.938,0,0,0-6.573,6.171,11.952,11.952,0,0,0-1.4,4.466,6.833,6.833,0,0,1,8.866,9.363c-2.212,4.327-7.377,4.1-10.072,2.116a9.381,9.381,0,0,1-3.655-5.852,14.829,14.829,0,0,1,3.236-12.711,21.1,21.1,0,0,1,7.674-5.928C529.87,391.91,529.94,391.89,530.028,391.858Z",
    transform: "translate(-141.275 -0.476)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28426",
    "data-name": "Path 28426",
    d: "M369.636,391.317l1.745,2.522c-4.246,2.359-7.3,5.585-8,10.662a5.89,5.89,0,0,1,2.934-.616,6.777,6.777,0,0,1,6.69,5.587,6.652,6.652,0,0,1-7.483,7.768,7.87,7.87,0,0,1-6.307-5.129,13.181,13.181,0,0,1-.052-10.143,18.263,18.263,0,0,1,7.612-9.016C367.683,392.367,368.652,391.876,369.636,391.317Z",
    transform: "translate(0 0)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes);
export default __webpack_public_path__ + "static/media/quotes.b3d9b889f7f8391c556245fb00b255f3.svg";
export { ForwardRef as ReactComponent };